"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var prop_types_1 = __importDefault(require("prop-types"));

var react_date_picker_1 = __importDefault(require("react-date-picker"));

var SzIcon_1 = __importDefault(require("../SzIcon/SzIcon"));

require("./SzDatePicker.scss");

function SzDatePicker(props) {
  var dateRange = props.dateRange,
      startDate = props.startDate,
      endDate = props.endDate,
      startMinDate = props.startMinDate,
      endMinDate = props.endMinDate,
      onChangeStartDate = props.onChangeStartDate,
      onChangeEndDate = props.onChangeEndDate;
  var calendarIcon = react_1.default.createElement(SzIcon_1.default, {
    icon: 'arrow-down-1',
    variant: "bold",
    className: "normal"
  });
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(react_date_picker_1.default, {
    onChange: onChangeStartDate,
    value: startDate,
    calendarIcon: calendarIcon,
    clearIcon: null,
    className: 'sz-datepicker',
    minDetail: 'year',
    minDate: startMinDate
  }), dateRange && react_1.default.createElement(react_date_picker_1.default, {
    onChange: onChangeEndDate,
    value: endDate,
    calendarIcon: calendarIcon,
    clearIcon: null,
    className: 'sz-datepicker',
    minDetail: 'year',
    minDate: endMinDate
  }));
}

exports.default = SzDatePicker;
SzDatePicker.protoTypes = {
  onChangeStartDate: prop_types_1.default.func,
  onChangeEndDate: prop_types_1.default.func
};
SzDatePicker.defaultProps = {
  startDate: new Date(),
  endDate: new Date(),
  startMinDate: null,
  endMinDate: null
};